import customAlert from './customAlert'
import request from "@/api/request"

const global = {
    setProfile(profile){
        localStorage.setItem('profile', profile)
    },
    redirect(url=''){
        window.location.href = url
    },
    reloadpage(){
        window.location.reload()
    },
    debounce: function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    },
    download(dataurl, filename) {
        // const link = document.createElement("a");
        // link.href = dataurl;
        // link.download = filename;
        // link.setAttribute('download',"download")
        // link.setAttribute('target',"_blank")
        // link.click();
    },
    customAlert,
    request
}

export default global